import { Controller } from "@hotwired/stimulus"

// Keeps the typed-discount field's placeholder in step with the armed ₫/% toggle.
// "50.000" is a useful example for money and a nonsensical one for a percent, and
// the toggle never round-trips to the server — the whole form submits at once.
export default class extends Controller {
  static targets = ["value"]
  static values = { placeholders: Object }

  apply() {
    const kind = this.element.querySelector("input[name=custom_discount_kind]:checked")?.value
    this.valueTarget.placeholder = this.placeholdersValue[kind] ?? ""
  }
}
